import React from "react";
import { useTranslation } from "react-i18next";
import image1 from "../../assets/custom-image.jpg";
import image2 from "../../assets/contactImage.jpg";
import "./AboutStyle.css";

const About = ({ id }) => {
  const { t, i18n } = useTranslation();

  const scrollToAppointmentBooking = () => {
    const AppointmentBookingElement =
      document.getElementById("AppointmentBooking");
    if (AppointmentBookingElement) {
      AppointmentBookingElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className={`about-us-section ${
        i18n.language === "ar" ? "rtl-layout" : ""
      }`}
      id={id}
    >
      <div className="image-column">
        <div className="image-container">
          <img
            src={image1}
            alt={t("aboutUs.image1Alt")}
            className="rounded-lg image-first"
          />
          <img
            src={image2}
            alt={t("aboutUs.image2Alt")}
            className="rounded-lg image-second"
          />
        </div>
      </div>
      <div className="content-column">
        <h4 className="section-subtitle">{t("aboutUs.about")}</h4>
        <h2 className="section-title">{t("aboutUs.mainTitle")}</h2>
        <p className="section-description">{t("aboutUs.description")}</p>
        <ul className="features-list">
          <li className="feature-item">
            <svg
              className="feature-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
            {t("aboutUs.features.personalized")}
          </li>
          <li className="feature-item">
            <svg
              className="feature-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
            {t("aboutUs.features.stateOfArt")}
          </li>
          <li className="feature-item">
            <svg
              className="feature-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
            {t("aboutUs.features.gentleCare")}
          </li>
          <li className="feature-item">
            <svg
              className="feature-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
            {t("aboutUs.features.flexibleScheduling")}
          </li>
        </ul>
        <button
          onClick={scrollToAppointmentBooking}
          className="appointment-button"
        >
          {t("aboutUs.bookAppointment")}
        </button>
      </div>
    </section>
  );
};

export default About;
